import { Switch, SwitchProps } from 'antd';
import clsx from 'classnames';
import React, { FC } from 'react';
import './index.scss';

interface TdsSwitchProps extends SwitchProps {
  size?: 'default' | 'small';
}
export const TdsSwitch: FC<TdsSwitchProps> = (props) => {
  const { className, size = 'default', ...rest } = props;

  return (
    <Switch className={clsx('tds-switch', size === 'default' ? 'tds-switch-default' : 'tds-switch-small', className)} {...rest} />
  );
};
